
import { energeticasProducts } from './energeticas';
import { abarrotesProducts } from './abarrotes';
import { aguaProducts } from './agua';
import { gaseosasProducts } from './gaseosas';
import { papelHigienicoProducts } from './papel-higienico';
import { isotonicasProducts } from './isotonicas';

export interface ProductDetail {
  id: number;
  uniqueId: string;
  name: string;
  image: string;
  unitsPerPack: number;
  packagingType: string;
  unitPrice: number;
  packPrice: number;
  palletPrice?: number | null;
  category: string;
  categorySlug: string;
}

export const allProductsList: ProductDetail[] = [
  ...energeticasProducts.map(p => ({
    ...p,
    uniqueId: `energeticas-${p.id}`,
    category: 'Energéticas',
    categorySlug: 'energeticas',
    palletPrice: p.palletPrice ?? null,
  })),
  ...abarrotesProducts.map(p => ({
    ...p,
    uniqueId: `abarrotes-${p.id}`,
    category: 'Abarrotes',
    categorySlug: 'abarrotes',
    palletPrice: p.palletPrice ?? null,
  })),
  ...aguaProducts.map(p => ({
    ...p,
    uniqueId: `agua-${p.id}`,
    category: 'Agua',
    categorySlug: 'agua',
    palletPrice: p.palletPrice ?? null,
  })),
  ...gaseosasProducts.map(p => ({
    ...p,
    uniqueId: `gaseosas-${p.id}`,
    category: 'Gaseosas',
    categorySlug: 'gaseosas',
    palletPrice: p.palletPrice ?? null,
  })),
  ...papelHigienicoProducts.map(p => ({
    ...p,
    uniqueId: `papel-higienico-${p.id}`,
    category: 'Papel Higiénico',
    categorySlug: 'papel-higienico',
    palletPrice: p.palletPrice ?? null,
  })),
  ...isotonicasProducts.map(p => ({
    ...p,
    uniqueId: `isotonicas-${p.id}`,
    category: 'Isotónicas',
    categorySlug: 'isotonicas',
    palletPrice: p.palletPrice ?? null,
  })),
];

export const findProductByUniqueId = (uniqueId: string): ProductDetail | undefined => {
  return allProductsList.find(p => p.uniqueId === uniqueId);
};
